import { ReactNode } from 'react';

import { Typography } from '@speeki/global-ui-components';

import { StatsFrameWrapper, ValueSkeleton } from './StatsFrame.styled';

export interface StatsFrameProps {
    isDisabled?: boolean;
    label: ReactNode;
    loading?: boolean;
    value: number;
}

export const StatsFrame = ({
    isDisabled,
    label,
    loading,
    value,
}: StatsFrameProps) => {
    return (
        <StatsFrameWrapper isDisabled={isDisabled}>
            {loading ? (
                <ValueSkeleton height={34} />
            ) : (
                <Typography.TextH3_24_34>{value}</Typography.TextH3_24_34>
            )}
            {typeof label === 'string' ? (
                <Typography.TextBody_10_16>{label}</Typography.TextBody_10_16>
            ) : (
                label
            )}
        </StatsFrameWrapper>
    );
};
